import { compile } from "path-to-regexp";
import type { BookingType } from "../pages/bookings/BookingType";
import type { DocumentActionType } from "./DocumentActions";

function compileUrl<Params extends object = object>(
  ...params: Parameters<typeof compile>
) {
  return compile<Params>(params[0], {
    ...params[1],
    encode: encodeURIComponent
  });
}

export const getSignatureUrl = compileUrl<{ id: string }>(
  "/rest-api/signatures/:id"
);

export const getSignDocUrl = compileUrl<{
  type: BookingType;
  id: string;
}>("/rest-api/srmsigndoc/:type/:id/");

export const getBookingSignatureUrl = compileUrl<{
  type: BookingType;
  id: string;
}>("/rest-api/:type/:id/signatures/");

export const getSignatureActivitiesUrl = compileUrl<{
  type: BookingType;
  id: string;
}>("/rest-api/:type/:id/signature-activities/");

export const getSrmPdfUrl = compileUrl<{
  type: DocumentActionType;
  id: string;
  subId?: string;
}>("/rest-api/srmrecord/pdf/:type/:id/:subId?");

export const getSrmSignDocUrl = compileUrl<{
  type: DocumentActionType;
  id: string;
  subId?: string;
}>("/rest-api/srmsigndoc/:type/:id/:subId?/");

export const getDocumentEmailUrl = compileUrl<{
  type: DocumentActionType;
  id: string;
  subId?: string;
}>("/rest-api/email/:type/:id/:subId?/");

export const getSignDocumentEmailUrl = compileUrl<{
  type: DocumentActionType;
  id: string;
  subId?: string;
}>("/rest-api/signdoc/email/:type/:id/:subId?/");

export const getSRMRecords = compileUrl<{
  recordCategory: string;
  recordType: string;
  recordKey: string;
}>("/rest-api/srmrecord/:recordCategory/:recordType/:recordKey");

export const getProductPrice = compileUrl<{ id: string }>(
  "/rest-api/srmrecord/price/product/:id"
);

export const getUpdateProductPrice = compileUrl<{ id: string }>(
  "/rest-api/update/getPrice/product/:id"
);

export const payDocument = compileUrl<{
  documentType: string;
  documentNumber: string;
}>(`/rest-api/:documentType-payments/:documentNumber`);

export const getPaymentModalConfig = compileUrl<{ customerNumber: string }>(
  "/rest-api/payment-configs/:customerNumber"
);

export const getPartSerialNumberUrl = compileUrl<{ id: string }>(
  "/parts/:id/serial_numbers/"
);

export const postCardReaderPaymentURL = compileUrl<{}>(
  "/rest-api/card-readers"
);

export const getCardReaderPaymentURL = compileUrl<{ paymentID: string }>(
  "/rest-api/card-readers/:paymentID"
);

export const updateInvoiceUrl = compileUrl<{ id: string }>(
  "/rest-api/edit/invoice/:id"
);

export const postInvoiceUrl = compileUrl<{}>("/rest-api/create/invoice");

export const getOldRentalStatusUrl = compileUrl<{}>(
  "/misc_settings/rental_status/"
);

export const getRentalStatusForOpenContractUrl = compileUrl<{}>(
  "/misc_settings/rental-status/open-contracts"
);

export const rental_return_page_2 = compileUrl<{ contract_no: string }>(
  "/returns/rentalreturn/2/:contract_no"
);

export const getActivitiesUrl = compileUrl<{}>(
  "/rest-api/activity/"
);

export const getMechanicUrl = compileUrl<{}>(
  "/rest-api/mechanics"
);

export const getDriversUrl = compileUrl<{}>(
  "/rest-api/drivers"
);

export const getForgotPasswordUrl = compileUrl<{}>(
  "/rest-api/forgot_password"
);

export const getMaintenancScheduleUrl = compileUrl<{ workorderId: string }>(
  "/rest-api/workorders/:workorderId/maintenance_schedules"
);

export const getWorkOrderDetailUrl = compileUrl<{ id: string }>(
  "/rest-api/workorders/:id"
);

export const getWorkorderByNumberUrl = compileUrl<{ workorderNumber: number }>(
  "/rest-api/srmrecord/workorder/:workorderNumber"
);

export const getCreateSiteUrl = compileUrl<{ customerNumber: string }>(
  "/rest-api/create/site/:customerNumber"
);

export const operatorPermissionUrl = compileUrl<{ userId: number, division?: string }>(
  "/rest-api/operators/:userId/:division?"
);

export const customerAllowedNamesUrl = compileUrl<{ customerNumber: string }>(
  "/customers/:customerNumber/allowed-names"
);

export const suggestedProductsUrl = compileUrl<{ sslNumber: string }>(
  "/inventory/suggested-products/:sslNumber"
);

export const updateCustomer = compileUrl<{ customerNumber: number }>(
  "/rest-api/update/customer/:customerNumber"
);

export const workOrderEstimateUrl = compileUrl<{}>(
  "/work-order-estimates"
);
